import { routeConstants } from '../../shared/constants';
import Invitation from "./";

const route = {
  exact: true,
  path: routeConstants.INVITATION.route,
  component: Invitation
};

export default route;
